let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5n9Ut")).then(() => parcelRequire('1zo8U'));